import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function nextPaymentReducer(
  state = initialState.nextPayment,
  action
) {
  switch (action.type) {
    case types.LOAD_NEXT_PAYMENT_SUCCESS:
      return action.nextPayment;
    default:
      return state;
  }
}
